import React from "react";
import { AlertTriangle, X } from "lucide-react";

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="landing-modal-overlay" onClick={onClose}>
      <div
        className="landing-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="landing-modal-header">
          <div className="landing-modal-icon">
            <AlertTriangle size={24} />
          </div>
          <h3>{title}</h3>
          <button className="landing-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="landing-modal-body">
          <p>{message}</p>
        </div>
        <div className="landing-modal-actions">
          <button
            className="landing-button landing-button-outline"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="landing-button landing-button-primary"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
